import { EmptyStateProcessIllustration } from "@octopusdeploy/design-system-components";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
interface TemplatedProjectOnboardingProps {
    projectTemplateSlug: string;
    version: string;
}
const TemplatedProjectOnboarding = ({ projectTemplateSlug, version }: TemplatedProjectOnboardingProps) => {
    return (<OnboardingPage title="Process managed by Project Template" intro={`This deployment process is managed by the project template ${projectTemplateSlug}, version ${version}. The process steps are defined by the template and cannot be modified directly.`} learnMore={<></>} image={<EmptyStateProcessIllustration />}/>);
};
export default TemplatedProjectOnboarding;
